import { render, staticRenderFns } from "./doctorDetails.vue?vue&type=template&id=9312dffa&"
import script from "./doctorDetails.vue?vue&type=script&lang=js&"
export * from "./doctorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports